import { COMPANY_NAME_MAX_LENGTH, COMPANY_NAME_MIN_LENGTH } from './constants';
import { validateMaxLength } from '@framework/ui/Organisms/FinalForm/validators/validateMaxLength';
import { validateMinLength } from '@framework/ui/Organisms/FinalForm/validators/validateMinLength';
import { IValidationError } from '../interfaces/ValidationError';

interface IParams {
  value: string | undefined,
  fieldName: string,
  fieldCaption: string,
  firstName?: string,
}

 interface IErrorMessages {
  minLength?: (params: { fieldCaption?: string, length: number }) => string,
  maxLength?: (params: { fieldCaption?: string, length: number }) => string,
 }

export const validateCompanyName = (params: IParams, errorMessages?: IErrorMessages): IValidationError => {
  const minLengthError = validateMinLength({ ...params, length: COMPANY_NAME_MIN_LENGTH }, errorMessages?.minLength);
  if (minLengthError) {
    return minLengthError;
  }
  const maxLengthError = validateMaxLength({ ...params, length: COMPANY_NAME_MAX_LENGTH }, errorMessages?.maxLength);
  if (maxLengthError) {
    return maxLengthError;
  }
  // @ts-ignore
  return null;
};
